import { pushToDataLayer } from '@almbrand/trackinghooks';
import { useDeviceQuery } from '@almbrand/usedevicequery';
import { downloadBlob, formatDate, getFileExtension, previewDocumentById } from 'common/DocumentService';
import { useState } from 'react';

const useDocumentPreview = () => {
	const { isMobile, isTablet } = useDeviceQuery();
	const [openModal, setOpenModal] = useState(false);
	const [error, setError] = useState(false);

	const [previewDocument, setPreviewDocument] = useState<PreviewDocument>({
		data: '',
		blobData: null,
		displayAsPdf: false,
		name: '',
		date: '',
		contentType: '',
	});

	const handleMessageClick = async (
		documentId: string,
		title: string,
		date: string,
		trackingData?: Record<string, unknown>,
		searchTrackingData?: Record<string, unknown>
	) => {
		try {
			const response = await previewDocumentById(documentId, date, title);

			if (trackingData) pushToDataLayer(trackingData);
			if (searchTrackingData) pushToDataLayer(searchTrackingData);

			if (isMobile || isTablet) {
				const blob = new Blob([response.blobData], { type: response.contentType });
				downloadBlob(blob, title, getFileExtension(response.contentType), formatDate(date) || '');
				return;
			}

			await setPreviewDocument({
				data: response.serializedData,
				blobData: response.blobData,
				displayAsPdf: response.displayAsPdf,
				name: title || '',
				date: formatDate(date) || '',
				contentType: response.contentType || '',
			});

			await setOpenModal(true);
		} catch (error) {
			console.error('Error fetching document:', error);
			setError(true);
		}
	};

	const handleMessageDownload = async () => {
		const blob = new Blob([previewDocument.blobData], { type: previewDocument.contentType });
		downloadBlob(blob, previewDocument.name, getFileExtension(previewDocument.contentType), previewDocument.date);
	};

	const onModalClose = () => setOpenModal(false);
	const resetError = () => setError(false);

	return {
		openModal,
		previewDocument,
		error,
		handleMessageClick,
		handleMessageDownload,
		onModalClose,
		resetError,
	};
};

export default useDocumentPreview;
